module.exports = __webpack_public_path__ + "img/box-chog.89dab4d9.png";